import React from "react";
import type { ReactNode } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import "../shell/panel/blockSettings/emailBuilderBlockSettings.scss";
import { EmailBuilderSettingsAccordion } from "./accordion/EmailBuilderSettingsAccordion";
import { useSettingsPanelHosted } from "./settingsPanelHostContext";

export function Panel({
  title,
  header,
  ariaLabel,
  defaultExpandedSectionIds,
  children,
}: {
  title?: string;
  header?: ReactNode;
  ariaLabel?: string;
  defaultExpandedSectionIds?: readonly string[];
  children: ReactNode;
}) {
  const { t } = useTranslation();
  const hosted = useSettingsPanelHosted();
  const resolvedAriaLabel =
    ariaLabel ?? t("{{title}} settings", { title: title ?? t("Settings") });
  const showInnerHeader = !hosted && header === undefined && title !== undefined;

  return (
    <aside
      className={classNames("email-builder-settings-panel", hosted && "email-builder-settings-panel--hosted")}
      aria-label={resolvedAriaLabel}
      data-editor-region="settings">
      {header ?? (showInnerHeader ? (
        <div className={"email-builder-settings-panel__head"}>
          <h2 className={"email-builder-settings-panel__title"}>{title}</h2>
        </div>
      ) : null)}
      <div className={"email-builder-settings-panel__body"}>
        <EmailBuilderSettingsAccordion
          defaultExpandedSectionIds={defaultExpandedSectionIds}
          className="email-builder-block-settings email-builder-block-settings--accordion"
        >
          {children}
        </EmailBuilderSettingsAccordion>
      </div>
    </aside>
  );
}
